import { combineReducers } from 'redux';
import type { Query } from '../query-param-adapter/model/index.tsx';
import analyticsData, { type AnalyticsDataState } from './analytics/reducer.tsx';
import components, { type ComponentsState } from './components/reducer.tsx';
import context, { type ContextState } from './context/reducer.tsx';
import project, { type ProjectState } from './project/reducer.tsx';
import query from './query/reducer.tsx';
import ui, { type UiState } from './ui/reducer.tsx';

export type State = {
	readonly components: ComponentsState;
	readonly project: ProjectState;
	readonly ui: UiState;
	readonly context: ContextState;
	readonly analyticsData: AnalyticsDataState;
	readonly query: Query;
};

const combinedReducer = combineReducers({
	components,
	project,
	ui,
	context,
	analyticsData,
	query,
});

export default combinedReducer;
